export const STORIES_COUNT = 6;
export const MIN_STORIES_COUNT = 3;
